import React, { createContext, useContext, useMemo } from 'react'

const AuthModeContext = createContext({
  isSkipAuth: false,
  isProdMode: false,
  isTestingMode: false,
})

export const useAuthMode = () => {
  const context = useContext(AuthModeContext)
  if (!context) {
    throw new Error('useAuthMode must be used within AuthModeProvider')
  }
  return context
}

export const AuthModeProvider = ({ children }) => {
  const value = useMemo(() => {
    const isProdMode = process.env.REACT_APP_INSTANCE_ENVIRONMENT === 'prod'
    const isTestingMode = window.location.search.includes('testing')
    const isSkipAuth = !isProdMode && isTestingMode

    return {
      isSkipAuth,
      isProdMode,
      isTestingMode,
    }
  }, [])

  return (
    <AuthModeContext.Provider value={value}>
      {children}
    </AuthModeContext.Provider>
  )
}
